import axios from "axios";
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { apiKey } from "../../config/config";
import { FaArrowLeftLong } from "react-icons/fa6";

function WebsiteSidebar() {
  const customer = JSON.parse(localStorage.getItem("rms-customer"));
  const navigate = useNavigate();

  const handleLogout = () => {
    axios
      .post(
        `${apiKey}/api/rms/customer/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${customer?.token}`,
          },
        }
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        localStorage.removeItem("rms-customer");
        navigate("/");
      });
  };
  return (
    <aside className="w-[240px] bg-white relative z-20">
      <div className="shadow-lg p-4 rounded-lg h-screen lg:h-auto">
        <button
          onClick={() => navigate(-1)}
          className="rounded-full p-4 border border-w-border my-4 group text-w-btn hover:bg-w-btn hover:text-w-btn-text"
        >
          <FaArrowLeftLong />
        </button>
        <ul className="font-semibold text-xl my-4">
          <li className="border-b">
            <NavLink
              to={""}
              end
              className={`p-2 my-1 rounded-md hover:bg-w-btn hover:text-w-btn-text w-full inline-block`}
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "var(--color-w-btn)" : "",
                  color: isActive ? "var(--color-w-btn-text)" : "",
                };
              }}
            >
              My Orders
            </NavLink>
          </li>
          <li className="border-b">
            <NavLink
              to={"myAddress"}
              end
              className={`p-2 my-1 rounded-md hover:bg-w-btn hover:text-w-btn-text w-full inline-block`}
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "var(--color-w-btn)" : "",
                  color: isActive ? "var(--color-w-btn-text)" : "",
                };
              }}
            >
              My Addresses
            </NavLink>
          </li>
          <li className="border-b">
            {/* <NavLink
              to={"wishlist"}
              className={`p-2 my-1 rounded-md hover:bg-w-btn hover:text-w-btn-text w-full inline-block`}
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "var(--color-w-btn)" : "",
                  color: isActive ? "var(--color-w-btn-text)" : "",
                };
              }}
            >
              Wish List
            </NavLink> */}
          </li>
          <li className="border-b">
            <NavLink
              to={"loyalty"}
              className={`p-2 my-1 rounded-md hover:bg-w-btn hover:text-w-btn-text w-full inline-block`}
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "var(--color-w-btn)" : "",
                  color: isActive ? "var(--color-w-btn-text)" : "",
                };
              }}
            >
              Loyalty Points
            </NavLink>
          </li>
          <li className="border-b">
            <NavLink
              to={"profile"}
              className={`p-2 my-1 rounded-md hover:bg-w-btn hover:text-w-btn-text w-full inline-block`}
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "var(--color-w-btn)" : "",
                  color: isActive ? "var(--color-w-btn-text)" : "",
                };
              }}
            >
              Profile
            </NavLink>
          </li>
          <li className="border-b">
            <NavLink
              to={"subscription-details"}
              className={`p-2 my-1 rounded-md hover:bg-w-btn hover:text-w-btn-text w-full inline-block relative`}
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "var(--color-w-btn)" : "",
                  color: isActive ? "var(--color-w-btn-text)" : "",
                };
              }}
            >
              Become a Subscriber
            </NavLink>
          </li>
          <li className="border-b">
            <NavLink
              to={"/subscriptions"}
              className={`p-2 my-1 rounded-md hover:bg-w-btn hover:text-w-btn-text w-full inline-block`}
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "var(--color-w-btn)" : "",
                  color: isActive ? "var(--color-w-btn-text)" : "",
                };
              }}
            >
              Subscriptions
            </NavLink>
          </li>
        </ul>
        <button
          onClick={() => handleLogout()}
          className="my-4 rounded border border-w-border py-2 px-4 text-w-btn hover:bg-w-btn hover:text-w-btn-text"
        >
          Logout
        </button>
      </div>
    </aside>
  );
}

export default WebsiteSidebar;
